<template>
  <div class="content-box">
    <div class="content-body contant-wrap">
      <el-card>
        <el-tabs v-model="activeName" @tab-click="changeTab">
          <el-tab-pane label="机构信息" name="info"></el-tab-pane>
          <el-tab-pane label="药品/项目" name="project"></el-tab-pane>
          <el-tab-pane label="进销存" name="inv"></el-tab-pane>
          <el-tab-pane label="冲正交易记录" name="transactionRecords"></el-tab-pane>
        </el-tabs>
        <template v-if="activeName === 'info'">
          <el-form :model="institutionInfo" label-width="100px" style="width: 365px;">
            <el-form-item label="医保服务" prop="fixmedinsType">
              <span class="opened">已开通</span>
            </el-form-item>
            <el-form-item label="服务类型" prop="fixmedinsType">
              <el-select v-model="institutionInfo.fixmedinsType" placeholder="请选择医保机构类型" class="input" disabled>
                <el-option :label="item.label" :value="item.value" v-for="item in fixmedinsTypeList"
                  :key='item.label'></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="机构代码" prop="fixmedinsCode">
              <el-input v-model="institutionInfo.fixmedinsCode" class="input" disabled></el-input>
            </el-form-item>
            <el-form-item label="定点机构">
              <el-input v-model="institutionInfo.fixmedinsName" class="input" disabled></el-input>
            </el-form-item>
            <el-form-item label="医保区划">
              <el-input v-model="institutionInfo.mdtrtareaAdmvs" class="input" disabled></el-input>
            </el-form-item>
            <!-- <el-form-item label="定点类型" prop="type">
            <el-input v-model="institutionInfo.type" class="input" disabled></el-input>
          </el-form-item> -->
            <!-- <el-form-item label="应用账户编码" prop="accessKey">
            <el-input v-model="institutionInfo.accessKey" class="input" type="textarea" disabled></el-input>
          </el-form-item>
          <el-form-item label="应用账户密钥" prop="secretKey">
            <el-input v-model="institutionInfo.secretKey" class="input" type="textarea" disabled></el-input>
          </el-form-item> -->
            <!-- <div class="line"></div> -->
          </el-form>
        </template>

        <!-- 药品/项目管理 -->
        <template v-if="activeName === 'project'">
          <!-- 搜索 -->
          <div class="search-box">
            <div class="left">
              <el-input style="width: 400px;" v-model="searchQuery.itemName" placeholder="请输入项目名称">
                <el-button slot="append" icon="el-icon-search" @click="getProjectList"></el-button>
              </el-input>
              <el-select
                  style="width: 150px;margin:0 20px;"
                  placeholder="请选择目录类别"
                  v-model="searchQuery.listType"
                  @change="getProjectList"
              >
                <el-option label="全部" value=""></el-option>
                <el-option :label="item.label" :value="item.value" v-for="item in listTypeList" :key='item.label'></el-option>
                <!-- <el-option label="西药中成药" value="101"></el-option>
                <el-option label="中药饮片" value="102"></el-option>
                <el-option label="自制剂" value="103"></el-option>
                <el-option label="医疗服务项目" value="201"></el-option>
                <el-option label="医用耗材" value="301"></el-option> -->
              </el-select>
              <el-select style="width: 150px;" v-model="searchQuery.uploadStatus" placeholder="请选择上传状态" @change="getProjectList">
                <el-option label="全部" value=""></el-option>
                <el-option label="未上传" value="0"></el-option>
                <el-option label="已上传" value="1"></el-option>
                <el-option label="已撤销" value="2"></el-option>
              </el-select>
            </div>
            <el-button type="primary" class="search-btn" @click="contrast">批量上传</el-button>
          </div>

          <!-- 列表展示 -->
          <el-table
            ref="dialogDrugsTableRef"
            :data="projectList"
            v-loading="tableLoading"
            @select="dialogHandleSelect"
            @select-all="dialogHandleSelectAll"
          >
            <el-table-column type="selection" width="60" :selectable="selectableDisabled" />
            <el-table-column label="项目名称" prop="itemName" width="250"></el-table-column>
            <el-table-column label="目录类别" prop="listType">
              <!-- <template slot-scope="{row}">
                {{ row.listType | listTypeFilter(listTypeList) }}
              </template> -->
            </el-table-column>
            <el-table-column label="医疗目录编码" prop="medListCodg" min-width="250"></el-table-column>
            <!-- <el-table-column label="规格包装" prop="specificationRemark"></el-table-column> -->
            <el-table-column label="上传状态" prop="uploadStatus" min-width="100">
              <!-- <template slot-scope="{row}">
                <span v-if="row.uploadStatus == 1">已上传</span>
                <span v-if="row.uploadStatus == 2">已撤销</span>
                <span v-else>未上传</span>
              </template> -->
            </el-table-column>
            <el-table-column label="开始日期" prop="begndate"></el-table-column>
            <el-table-column label="结束日期" prop="enddate"></el-table-column>
            <el-table-column label="创建时间" prop="gmtCreate" width="180"></el-table-column>
            <el-table-column label="操作" prop="gmtModified" v-if="!searchQuery.uploadStatus || searchQuery.uploadStatus == '1'">
              <template slot-scope="{row}">
                <el-button type="text" size="small" @click="revoke(row)" v-if="row.uploadStatus == '已上传'">撤销</el-button>
              </template>
            </el-table-column>
          </el-table>

          <!-- 分页 -->
          <div class="pagination-box">
            <!--<el-pagination-->
            <!--  background-->
            <!--  layout="total, sizes, prev, pager, next"-->
            <!--  :total="searchQuery.total"-->
            <!--  :page-size.sync="searchQuery.limit"-->
            <!--  @current-change="handleCurrentChange"-->
            <!--&gt;-->
            <!--</el-pagination>-->
            <el-pagination
              background
              layout="total, sizes, prev, pager, next"
              :current-page="searchQuery.page"
              :page-sizes="[10, 20, 50, 100]"
              :page-size.sync="searchQuery.limit"
              :total="searchQuery.total"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
            >
            </el-pagination>
          </div>
        </template>

        <!-- 进销存 -->
        <template v-if="activeName === 'inv'">
          <div style="margin-bottom: 20px; display: flex">
            <div class="circle-class" :style="{backgroundColor: invRequired == 1 ?  '#e3fced' : '#f0f4ff'}">
              <i class="circle-icon"
                 :class="invRequired == 1 ? 'el-icon-folder-checked' : 'el-icon-folder-delete'"
                 :style="{color: invRequired == 1 ? '#1ec761' : '#aab4bf'}"></i>
            </div>
            <div class="icon-right-box">
              <b>{{ invRequired == 1 ? '已开启' : '已关闭' }}</b>
              <div style="color: #aab4bf">
                {{
                  invRequired == 1 ?
                      '自动上报已开启，系统每隔两个小时自动上报一次' :
                      '对接医保中心，按监管要求上报进销存数据，支持自动上报，减少医保违规风险'
                }}
              </div>
            </div>
            <template v-if="invRequired == 1">
              <el-button class="button-right" type="danger" plain @click="openReport(0)">
                停用
              </el-button>
            </template>
            <template v-else>
              <el-button class="button-right" type="primary" @click="openReport(1)">
                立即开启
              </el-button>
            </template>
          </div>
          <b>上报明细</b>
          <el-divider />
          <el-row :gutter="20" class="filter-row">
            <el-col :span="6">
              <!-- HH:mm:ss :default-time="['00:00:00', '23:59:59']" -->
              <el-date-picker v-model="invTime" type="daterange" align="right" unlink-panels range-separator="至"
                              start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions" @change="getDate"
                              value-format="yyyy-MM-dd" style="width: 100%">
              </el-date-picker>
            </el-col>
            <el-col :span="2">
              <el-select v-model="queryForm.invChgType" placeholder="全部动作" @change="getInvList()" class="container" clearable>
                <el-option v-for="item in dongzuoOption" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="2">
              <el-select v-model="queryForm.uploadStatus" placeholder="上报状态" @change="getInvList()" class="container" clearable>
                <el-option v-for="item in typeOption" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="3">
              <el-input placeholder="医保编码" v-model="queryForm.medListCodg" @keyup.enter.native="getInvList()"></el-input>
            </el-col>
            <el-col :span="3">
              <el-input placeholder="药品名称" v-model="queryForm.fixmedinsHilistName" @keyup.enter.native="getInvList()"></el-input>
            </el-col>
            <el-col :span="6">
              <el-button type="primary" @click="getInvList()">
                查询
              </el-button>
            </el-col>
            <el-col :span="2">
              <el-button plain @click="showUploadDialog">手动上报</el-button>
            </el-col>
          </el-row>
          <el-table :data="invTableData" :header-cell-style="{ 'font-weight': 'bold' }" style="width: 100%" class="table" v-loading="invLoading">
            <el-table-column label="药品名称" prop="fixmedinsHilistName"></el-table-column>
            <el-table-column label="规格" prop="specification"></el-table-column>
            <el-table-column label="厂家" prop="manufacturer"></el-table-column>
            <el-table-column label="医保编码" prop="medListCodg">
              <template slot-scope="scope">
                {{ scope.row.medListCodg || '--' }}
              </template>
            </el-table-column>
            <el-table-column label="动作" prop="invChgTypeDesc"></el-table-column>
            <el-table-column label="发生时间" prop="gmtCreate"></el-table-column>
            <el-table-column label="批号" prop="manuLotnum"></el-table-column>
            <el-table-column label="结算类型" prop="mdtrtSetlType"></el-table-column>
            <!--<el-table-column label="变更前库存" prop="beforeStock"></el-table-column>-->
            <!--<el-table-column label="库存数量" prop="changeStock"></el-table-column>-->
            <!--<el-table-column label="结余库存" prop="afterStock"></el-table-column>-->
            <el-table-column label="追溯码" prop="drugTracCodg">
              <template slot-scope="{row}">
                <el-tooltip v-if="row.drugTracCodg"
                            class="item" effect="dark" :content="row.drugTracCodg"
                            placement="top-start"
                >
                  <span>
                  已采集
                  </span>
                </el-tooltip>
                <span v-else style="color: red">
                  未采集
                </span>
              </template>
            </el-table-column>
            <el-table-column fixed="right" label="最近上报时间" prop="lastUploadTime"></el-table-column>
            <el-table-column fixed="right" label="备注" prop="remarks"></el-table-column>
            <el-table-column fixed="right" label="上报状态" prop="uploadStatusDesc">
              <template slot-scope="{row}">
                <span :style="{color: row.uploadStatus == '1' ? 'red' : '#000'}">
                  {{ row.uploadStatusDesc }}
                </span>
              </template>
            </el-table-column>
          </el-table>
          <div class="pagination">
            <el-pagination
                background
                @size-change="handleSizeChangeInv"
                @current-change="handleCurrentChangeInv"
                :current-page.sync="queryForm.page"
                :page-sizes="pageSizes"
                :page-size.sync="queryForm.limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalCount"
            >
            </el-pagination>
          </div>
        </template>

        <!-- 冲正交易记录 -->
        <template v-if="activeName === 'transactionRecords'">
          <!-- 搜索 -->
          <div class="search-box">
            <div class="left">
              <el-input placeholder="请输入项目名称" v-model="personnelRecordObj.params.name" style="width: 400px;" clearable>
                <el-button slot="append" icon="el-icon-search" @click="getPersonnelRecordList"></el-button>
              </el-input>
            </div>
          </div>

          <!-- 列表 -->
          <el-table :data="personnelRecordObj.list" v-loading="personnelRecordObj.loading" style="width: 100%;">
            <el-table-column type="selection" width="60" />
            <el-table-column label="患者名称" prop="name" min-width="100"></el-table-column>
            <el-table-column label="电话" prop="phone" min-width="120"></el-table-column>
            <el-table-column label="身份证号码" prop="idCard" min-width="200"></el-table-column>
            <!-- <el-table-column label="就诊id(mdtrt_id)" prop="mdtrtId" min-width="250"></el-table-column>
            <el-table-column label="收费编号" prop="chrgBchno" min-width="250"></el-table-column>
            <el-table-column label="险种" prop="insutype" min-width="250"></el-table-column>
            <el-table-column label="账户使用标志" prop="acctUsedFlag" min-width="250"></el-table-column>
            <el-table-column label="就诊方式" prop="psnSetlway" min-width="250"></el-table-column> -->
            <el-table-column label="订单号" prop="orderNo" min-width="200"></el-table-column>
            <el-table-column label="证件类型" prop="papersType" min-width="100">电子凭证</el-table-column>
            <el-table-column label="基金" prop="fund" min-width="100"></el-table-column>
            <!-- <el-table-column label="创建时间" prop="gmtCreate" min-width="250"></el-table-column>
            <el-table-column label="修改时间" prop="gmtModified" min-width="250"></el-table-column>
            <el-table-column label="是否删除" prop="isDeleted" min-width="250"></el-table-column> -->
            <el-table-column
              label="操作"
              width="100"
              align="center"
              fixed="right"
            >
              <template slot-scope="scope">
                <el-button type="text" @click="handleSettlement(scope.row)">结算</el-button>
              </template>
            </el-table-column>
          </el-table>

          <!-- 分页 -->
          <div class="pagination-box">
            <el-pagination
              background
              layout="total, prev, pager, next"
              :total="personnelRecordObj.total"
              @current-change="handlePageChange"
              :current-page.sync="personnelRecordObj.params.page"
              :page-size.sync="personnelRecordObj.params.limit"
            />
          </div>
        </template>
      </el-card>
    </div>

    <SimplifyPagDialog 
      ref="simplifyPagDialogRef" 
      :showCardReading.sync="showCardReading"
      :receivable="receivable"
      :orderNo="orderNo"
      @refresh="getPersonnelRecordList"
    ></SimplifyPagDialog>

    <el-dialog title="手动上报" :visible.sync="showUpload" width="30%">
      <el-form :model="uploadForm" ref="uploadForm" :rules="uploadRule" label-width="120px">
        <el-form-item label="日期：" prop="uploadTime">
          <el-date-picker
              v-model="uploadForm.uploadTime"
              type="daterange"
              align="right"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd HH:mm:ss"
              :default-time="['00:00:00', '23:59:59']"
              :picker-options="pickerOptions"
              style="width: 80%;"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="动作：" prop="invChgType">
          <el-select v-model="uploadForm.invChgType" placeholder="请选择" style="width: 80%;">
            <el-option
                v-for="item in dongzuoOption"
                :key="item.value"
                :label="item.label"
                :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item >
          <el-button @click="manualUpload" type="primary" size="small">确定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import getFields from '@/utils/inputMessage/index';
import { Loading } from 'element-ui';
import { pageSizes, pickerOptions } from "@/config/constant";
import {startDate} from "@/utils/filter";

import SimplifyPagDialog from "./components/pay-dialog/pay-dialog.vue";
import {getInvList, manualUploadCode} from "@/api/traceabilityCode";
export default {
  name: 'institutionalInformation',
  data () {
    return {
      activeName: 'info',
      institutionInfo: {},
      // 1定点医疗机构；2定点零售药店；3工伤定点康复机构；4辅助器具配置机构；5计划生育服务机构
      fixmedinsTypeList: [
        { value: '1', label: '定点医疗机构' },
        { value: '2', label: '定点零售药店' },
        { value: '3', label: '工伤定点康复机构' },
        { value: '4', label: '辅助器具配置机构' },
        { value: '5', label: '计划生育服务机构' },
      ],
      tableLoading: false,
      listTypeList: [
        { value: '101', label: '西药中成药' },
        { value: '102', label: '中药饮片' },
        { value: '103', label: '自制剂' },
        { value: '201', label: '医疗服务项目' },
        { value: '301', label: '医用耗材' },
      ],
      projectList: [],
      searchQuery: {
        limit: 10,
        page: 1,
        total: 0,
        itemName: '',
        listType: '',
        uploadStatus: ''
      },
      selectedProjectId: [],
      personnelRecordObj: {
        params: {
          limit: 10,//每页显示记录数
          page: 1,// 当前页
          name: ""	
        },
        total: 0,
        list: [],
        loading: false
      },
      // 弹窗
      showCardReading: false,//是否显示
      receivable: 0,//总金额
      orderNo: "",//订单号
      invLoading: false,
      invTableData: [],
      pageSizes, // 进销存
      pickerOptions, // 进销存
      totalCount: 0, //总条数
      invTime: [],
      queryForm: {
        invChgType: '',
        uploadStatus: '',
        medListCodg: '',
        fixmedinsHilistName: '',
        page: 1, //当前页数
        limit: 10, //每页条数
      },
      dongzuoOption: [
        {label: '调拨入库', value: '101'},
        {label: '调拨出库', value: '102'},
        {label: '盘盈', value: '103'},
        {label: '盘损', value: '104'},
        {label: '销毁', value: '105'},
        {label: '其他入库', value: '106'},
        {label: '其他出库', value: '107'},
      ],
      typeOption: [
        {label: '无需上报', value: '0'},
        {label: '未上报', value: '1'},
        {label: '已上报', value: '2'},
        {label: '上报失败', value: '3'},
      ],
      setParams: {},
      invRequired: 0, // 进销存批号日期是否必填  是否开启医保上报
      showUpload: false, // 手动上报弹窗
      uploadForm: {
        uploadTime: [],
        invChgType: '',
      },
      uploadRule:{
        uploadTime:[{ required: true, message: '请选择日期', trigger: 'blur' }],
        invChgType:[{ required: true, message: '请选择动作', trigger: 'blur' }],
      },
    }
  },
  components: {
    SimplifyPagDialog
  },
  computed: {
    countInfo () {
      return this.$store.state.global.countInfo
    },
    fixMedIns () {
      return this.$store.state.global.countInfo.fixMedIns
    },
  },
  filters: {
    listTypeFilter (val, listTypeList) {
      return (listTypeList.find(item => item.value == val) || { label: '--' }).label
    }
  },
  methods: {
    async getProjectList () {
      this.tableLoading = true
      const { data: { data } } = await this.$api.medicalInsurance.getMedInsItemList(this.searchQuery)
      this.tableLoading = false
      if (data.code == 200) {
        this.projectList = data.data.records
        this.searchQuery.total = data.data.total
        await this.$nextTick()
        this.tableRowSelected()
      }
    },
    handleCurrentChange(val) {
      this.searchQuery.page = val
      this.getProjectList()
    },
    handleSizeChange(val) {
      this.searchQuery.limit  = val;
      this.getProjectList()
    },
    async contrast () {
      if (this.selectedProjectId.length == 0) {
        return this.$message.error('请选择项目')
      }
      const res = await this.$api.medicalInsurance.medInsItemContrast({ medListUploadRecordIds: this.selectedProjectId })
      if (res.data.code == 200) {
        this.$message.success(res.data.message)
        this.selectedProjectId = []
        this.getProjectList()
      } else {
        this.$message.error(res.data.message)
      }
    },
    async revoke (row) {
      // const res = await this.$api.medicalInsurance.medInsItemRevoke({ medListUploadRecordIds: row.id })
      // if (res.data.code == 200) {
      //   this.$message.success(res.data.message)
      //   this.getProjectList()
      // } else {
      //   this.$message.error(res.data.message)
      // }
      let res = await this.$confirm('是否确认撤销?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).catch(() => { })
      if (res == 'confirm') {
        const res = await this.$api.medicalInsurance.medInsItemRevoke({ medListUploadRecordIds: [row.id] })
        if (res.data.code == 200) {
          this.$message.success(res.data.message)
          this.getProjectList()
        } else {
          this.$message.error(res.data.message)
        }
      }
    },
    selectableDisabled (row, rowIndex) {
      console.log('row: ', row);
      if (row.uploadStatus == '已上传') {
        return false;//禁用
      } else {
        return true;//不禁用
      }
    },
    dialogHandleSelect (selection, row) {
      let selectionId = selection.map(item => item.id)
      let selectedProjectId = this.selectedProjectId.includes(row.id) ? this.selectedProjectId.filter(item => item != row.id) : [...this.selectedProjectId, row.id]
      this.selectedProjectId = [...new Set([...selectionId, ...selectedProjectId])]
    },
    dialogHandleSelectAll (selection) {
      let selectionId = selection.map(item => item.id)
      let selectedProjectId = this.selectedProjectId.filter(item => {
        return !this.projectList.find(i => i.id == item)
      })
      this.selectedProjectId = [...new Set([...selectionId, ...selectedProjectId])]
    },
    // table默认选中
    tableRowSelected () {
      // 选中行list 
      this.selectedProjectId.map(item => {
        let row = this.projectList.find(i => i.id == item)
        row && this.$refs.dialogDrugsTableRef.toggleRowSelection(row, true);
      })
    },
    async getPersonnelRecordList() {
      this.personnelRecordObj.loading = true;
      const { data: { data } } = await this.$api.medicalInsurance.getPersonnelRecord(this.personnelRecordObj.params)
      this.personnelRecordObj.loading = false;
      this.personnelRecordObj.printListlist = data.records;
      this.personnelRecordObj.total = data.total;
    },
    handlePageChange(val) {
      this.personnelRecordObj.params.page = val;
      this.getPersonnelRecordList();
    },
    async handleSettlement(val) {
      this.showCardReading = true;
      this.receivable = val.fund;
      this.orderNo = val.orderNo
      await this.$nextTick();
      this.$refs.simplifyPagDialogRef.settlementDataProcess(val);
    },
    handleSizeChangeInv(val) {
      this.queryForm.limit = val
      this.getInvList()
    },
    handleCurrentChangeInv(val) {
      this.queryForm.page  = val;
      this.getInvList()
    },
    getDate(v) {
    },
    getInvList() {
      let startDate = this.invTime ? this.invTime[0] : ''
      let endDate = this.invTime ? this.invTime[1] : ''

      this.queryForm.startDate = startDate ? startDate.split(' ')[0] : ''
      this.queryForm.endDate = endDate ? endDate.split(' ')[0] : ''

      console.log(this.queryForm)
      this.invLoading = true
      this.$api.traceabilityCode.getInvList(this.queryForm).then((res) => {
        this.invTableData = res.data.data.records;
        this.totalCount = res.data.data.total;
      }).finally(() => {
        this.invLoading = false
      })
    },
    changeTab(v) {
      if (v.index == 2) {
        this.getInvList()
      }
    },
    // 进销存批号日期是否必填  是否开启医保上报
    async getInvRequired() {
      let res = await this.$api.clinicManagement.getHospitalConfig({ configType:22, })
      this.setParams = res
      this.invRequired = res.invRequired || 0;
    },
    // 开启/停止上报
    openReport(type) {
      let msg = type == 1 ? '正在开通进销存上报功能，系统即将上传进销存初始化数据到医保中心，是否继续？' : '关闭进销存上报功能后，将无法向医保中心上传进销存信息和追溯码信息，是否继续关闭？'
      this.$confirm(msg, "友情提示", {
        confirmButtonText: type == 1 ? '继续开启' : '继续关闭',
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.invRequired = type
        this.setParams.invRequired = type
        this.$api.clinicManagement.updateHospitalConfigAPI(this.setParams).then((res) => {
          this.$message({
            message: '操作成功！',
            type: 'success',
          });
        });
      })
    },
    showUploadDialog() {
      this.showUpload = true
    },
    // 手动上报
    manualUpload() {
      this.$refs.uploadForm.validate((valid) => {
        if (valid) {
          let startDate = this.uploadForm.uploadTime ? this.uploadForm.uploadTime[0] : ''
          let endDate = this.uploadForm.uploadTime ? this.uploadForm.uploadTime[1] : ''

          this.uploadForm.startDate = startDate ? startDate.split(' ')[0] : ''
          this.uploadForm.endDate = endDate ? endDate.split(' ')[0] : ''

          let params = JSON.parse((JSON.stringify(this.uploadForm)))
          delete params.uploadTime

          this.$api.traceabilityCode.manualUploadCode(params).then((res) => {
            this.$message.success('上报成功!')
            this.queryForm.page = 1
            this.queryForm.limit = 10
            this.getInvList()
            this.showUpload = false
          })
        } else {
          return false;
        }
      })
    }
  },
  mounted () {
    this.invTime = startDate(); // 设置默认日期
    this.uploadForm.uploadTime = startDate(); // 设置默认日期
    this.institutionInfo = JSON.parse(JSON.stringify(this.fixMedIns))
    this.institutionInfo.mdtrtareaAdmvs = `${this.fixMedIns.mdtrtareaAdmvs}(${this.fixMedIns.mdtrtareaLabel})`
    this.getInvRequired()
    this.getProjectList()
    this.getPersonnelRecordList()
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-card__header {
  border-bottom: none;
}

.opened {
  color: #009688;
  font-size: 14px;
  margin-left: 35px;
}

.line {
  width: 100%;
  height: 0px;
  opacity: 1;
  border: 1px solid rgba(82, 82, 82, 0.09);
}

.save-btn {
  margin-top: 25px;
}

.search-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;

  .left {
    display: flex;
    align-items: center;
    flex-shrink: 0;
  }
}

.pagination-box {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.circle-class {
  margin-right: 20px;
  width: 50px;
  height: 50px;
  border-radius: 50%;

  .circle-icon {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    font-size: 24px;
  }
}

.icon-right-box {
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  height: 50px;
}

.button-right {
  margin-top: 10px;
  height: 30px;
  line-height: 0;
}

::v-deep .el-divider--horizontal {
  margin-top: 10px;
}
</style>